import { create } from "zustand";
import { persist } from "zustand/middleware";

export default create(persist(
	(setState) => ({
		name: "",
		setName: (name) => setState({ name }),
		defaultPageSize: 5,
		setDefaultPageSize: (defaultPageSize) => setState({ defaultPageSize }),
		maxDSLScreen: false,
		setMaxDSLScreen: (maxDSLScreen) => setState({ maxDSLScreen }),
	}),
	{
		name: "locsys-global-state",
	},
));
